import { makeStyles } from '@material-ui/core';

export const useAppHeaderStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
    marginTop: 10,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.secondary,
  },
  box: {
    textAlign: 'center',
    fontFamily: 'Monospace',
    fontSize: 20,
  },
  logo: {
    width: '50px',
    height: '50px',
  },
}));
